import {
  GET_SALESDETAIL,
  GET_SALESDETAIL_SUCCESS,
  GET_SALESDETAIL_FAIL,
  DELETE_SALESDETAIL,
  DELETE_SALESDETAIL_SUCCESS,
  DELETE_SALESDETAIL_FAIL,
  UPDATE_SALESDETAIL,
  UPDATE_SALESDETAIL_SUCCESS,
  UPDATE_SALESDETAIL_FAIL,
  ADD_NEW_SALESDETAIL,
  ADD_SALESDETAIL_SUCCESS,
  ADD_SALESDETAIL_FAIL,
  SALESDETAIL_LOADING,
  SALESDETAIL_RESET,
} from "./actionType";

export const resetSalesDetailState = (actionType) => ({
  type: SALESDETAIL_RESET,
  payload: { actionType },
});

export const getSalesDetailSuccess = (actionType, data) => ({
  type: GET_SALESDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getSalesDetailFail = (actionType, error) => ({
  type: GET_SALESDETAIL_FAIL,
  payload: { actionType, error },
});

export const getSalesDetail = data => ({
  type: GET_SALESDETAIL,
  payload: data,
});

export const getSalesDetailLoading = () => ({
  type: SALESDETAIL_LOADING
});

export const deleteSalesDetail = data => ({
  type: DELETE_SALESDETAIL,
  payload: data,
});

export const deleteSalesDetailSuccess = data => ({
  type: DELETE_SALESDETAIL_SUCCESS,
  payload: data,
});

export const deleteSalesDetailFail = error => ({
  type: DELETE_SALESDETAIL_FAIL,
  payload: error,
});

export const updateSalesDetail = data => ({
  type: UPDATE_SALESDETAIL,
  payload: data,
});

export const updateSalesDetailFail = error => ({
  type: UPDATE_SALESDETAIL_FAIL,
  payload: error,
});

export const updateSalesDetailSuccess = data => ({
  type: UPDATE_SALESDETAIL_SUCCESS,
  payload: data,
});

export const addNewSalesDetail = data => ({
  type: ADD_NEW_SALESDETAIL,
  payload: data,
});

export const addSalesDetailSuccess = data => ({
  type: ADD_SALESDETAIL_SUCCESS,
  payload: data,
});

export const addSalesDetailFail = error => ({
  type: ADD_SALESDETAIL_FAIL,
  payload: error,
});